<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<header class="slds-page-header">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-icon_container slds-icon-standard-resource-capacity"
                title="Project Allocation">
            <svg aria-hidden="true" class="slds-icon slds-page-header__icon">
              <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#resource_capacity"></use>
            </svg>
            <span class="slds-assistive-text" i18n>Resource Allocation</span>
          </span>
        </div>
        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span i18n id="pa-hdr">Resource Allocation</span>
                <span class="slds-page-header__title" id="pa-name">{{resourceName}}</span>
              </h1>
            </div>
            <div class="slds-page-header__name-switcher">
              <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
                <button (click)="onResourceSelectClick()"
                        aria-haspopup="true"
                        class="slds-button slds-button_icon slds-button_icon-small"
                        i18n-title
                        id="pa-project-select" title="Select Resource">
                  <svg aria-hidden="true" class="slds-button__icon slds-icon_x-small">
                    <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#down"></use>
                  </svg>
                  <span class="slds-assistive-text" i18n>Select Resource</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">

        <div class="slds-page-header__control slds-show_medium">

          <div class="slds-avatar slds-m-right_small">
            <img *ngIf="busy" alt="Loading ..." id="busy" src="/assets/images/busy.svg" title="Loading ...">
          </div>
          <div class="slds-m-right_small slds-show_inline-block">
            <acc-help-button title="Resource Detail Allocation">
              Allocate Resources to Project Lines
              <ul class="slds-list_dotted">
              </ul>
            </acc-help-button>
          </div>

          <button (click)="doRefresh()"
                  class="slds-button slds-button_icon slds-button_icon-border"
                  id="ps-refresh" title="Refresh">
            <svg aria-hidden="true" class="slds-button__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#refresh"></use>
            </svg>
            <span class="slds-assistive-text" i18n>Refresh</span>
          </button>

          <button (click)="onReset()"
                  class="slds-button slds-button_neutral"
                  id="ps-reset">
            <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#undo"></use>
            </svg>
            <span i18n>Reset</span>
          </button>

          <button (click)="onSave($event)"
                  [disabled]="isSaveDisabled"
                  class="slds-button slds-button_neutral"
                  id="ps-save">
            <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#connected_apps"></use>
            </svg>
            <span i18n>Save</span>
          </button>

        </div>

      </div>
    </div>
  </div><!--header-row-->

  <!-- status -->
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-meta">
      <acc-status-line [error]="error" [message]="message"></acc-status-line>
    </div>
  </div>

  <div class="slds-page-header__row slds-page-header__row_gutters">
    <div class="slds-page-header__col-details">
      <ul class="slds-page-header__detail-row">

        <li class="slds-page-header__detail-blockX">
          <h2 class="slds-text-heading_small">Timeframe</h2>

          <div class="slds-form__row">
            <div class="slds-form__item" role="listitem">
              <fieldset class="slds-form-element">
                <legend class="slds-form-element__legend slds-form-element__label">Plan Granularity</legend>
                <div class="slds-form-element__control" style="display: inline-flex">
                  <span class="slds-radio">
                    <input (change)="onChangeGranularity($event)" checked id="plan-day5" name="options" type="radio"
                           value="plan-day5"/>
                    <label class="slds-radio__label" for="plan-day5">
                      <span class="slds-radio_faux"></span>
                      <span class="slds-form-element__label">Day(5)</span>
                    </label>
                  </span>
                  <span class="slds-radio">
                    <input (change)="onChangeGranularity($event)" id="plan-day7" name="options" type="radio"
                           value="plan-day7"/>
                    <label class="slds-radio__label" for="plan-day7">
                      <span class="slds-radio_faux"></span>
                      <span class="slds-form-element__label">Day(7)</span>
                    </label>
                  </span>
                  <span class="slds-radio">
                    <input (change)="onChangeGranularity($event)" id="plan-week" name="options" type="radio"
                           value="plan-week"/>
                    <label class="slds-radio__label" for="plan-week">
                      <span class="slds-radio_faux"></span>
                      <span class="slds-form-element__label">Week</span>
                    </label>
                  </span>
                </div>
              </fieldset>
            </div>
            <div class="slds-form__item" role="listitem">
              <acc-date-element (dateSelected)="onDateFromSelected($event)"
                                class="slds-form-element_horizontal"
                                label="Date From"
                                theId="dateFrom"></acc-date-element>
            </div>
            <div class="slds-form__item" role="listitem">
              <acc-date-element (dateSelected)="onDateToSelected($event)"
                                class="slds-form-element_horizontal"
                                label="Date To"
                                theId="dateTo"></acc-date-element>
            </div>
          </div>
          <div class="slds-clearfix">
            <div class="slds-float_left slds-text-color_success">{{timeFrameInfo}}</div>
            <div class="slds-float_left slds-m-left_medium slds-text-color_error">{{timeFrameError}}</div>
          </div>
        </li>

      </ul>
    </div>
  </div>

</header>


<div #main class="slds-m-vertical_medium">

  <section class="slds-scrollable scrollbars"
           id="resource">
    <table caption="Resource Allocations"
           class="slds-table slds-table_fixed-layout slds-table_bordered fixed-hc">
      <thead>
      <tr class="slds-line-height_reset">
        <th class="alloc-first"
            scope="col">
          <div class="slds-truncate" i18n>Project Line</div>
        </th>
        <th class="alloc-sum"
            i18n
            scope="col" title="Project Line Planned Effort | Project Allocation in time frame">Total
        </th>
        <th *ngFor="let day of headerInfoList"
            [class.alloc-day-first]="day.isWeekStartDay"
            [class.alloc-day-we]="day.isWeekend"
            [class.alloc-day-week]="day.isWeekly"
            [title]="day.title"
            class="alloc-day"
            scope="col">
          <div class="slds-truncate">{{day.label}}</div>
        </th>
      </tr>
      </thead>

      <tbody><!-- resource line -->
      <ng-container *ngIf="resourceInfo">
        <tr [title]="resourceInfo.title" class="slds-hint-parent"
            style="line-height: 3rem; background-color: aliceblue">
          <th class="alloc-first"
              scope="row">
            <div class="slds-truncate"><i>{{resourceInfo.label}}</i></div>
          </th>
          <td class="alloc-sum" title="Planned Effort">{{resourceInfo.sum}}</td>
          <td *ngFor="let rd of resourceInfo.dayList"
              [class.alloc-capacity]="rd.isCapacity"
              [class.alloc-day-first]="rd.isWeekStartDay"
              [class.alloc-day-we]="rd.isWeekend"
              [class.alloc-day-week]="rd.isWeekly"
              [class.alloc-over]="rd.isOver"
              [title]="rd.title"
              class="alloc-day">
            <div class="slds-truncate">{{rd.stringValue}}</div>
          </td>
        </tr>
      </ng-container>
      </tbody>

      <tbody><!-- allocation lines -->
      <tr *ngFor="let ra of allocationInfoList"
          [attr.data-value]="ra.name"
          class="slds-hint-parent">
        <th [title]="ra.title"
            class="alloc-first"
            scope="row">
          <div class="slds-truncate">
            <button (click)="onProjectLineResourceDelete(ra)"
                    class="slds-button slds-button_icon slds-button_icon-border-filled"
                    style="vertical-align: top"
                    title="Delete Allocation">
              <svg aria-hidden="true" class="slds-button__icon">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#delete"></use>
              </svg>
              <span class="slds-assistive-text">Delete Allocation</span>
            </button>
            <div class="slds-m-horizontal_small slds-show_inline-block"><b>{{ra.projectName}}</b>:<br/>{{ra.projectLineName}}</div>
            <button (click)="onProjectLineResourceChange(ra)"
                    class="slds-button slds-button_icon slds-m-top_x-small slds-float_right" title="Edit">
              <svg aria-hidden="true" class="slds-button__icon">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#edit"></use>
              </svg>
              <span class="slds-assistive-text">Edit</span>
            </button>
          </div>

        </th>
        <td class="alloc-sum">
          {{ra.sum}}
        </td>
        <td *ngFor="let ad of ra.dayList"
            [class.alloc-day-first]="ad.isWeekStartDay"
            [class.alloc-day-we]="ad.isWeekend"
            [class.alloc-day-week]="ad.isWeekly"
            class="alloc-day">
          <input (change)="onInputChange($event, ra, ad)"
                 (dblclick)="onInputDblClick($event, ra, ad)"
                 *ngIf="ad.isDisplayed"
                 [id]="ad.id"
                 [name]="ad.id"
                 [title]="ad.title"
                 [value]="ad.stringValue"
                 class="slds-input"/>
        </td>
      </tr>
      </tbody>

    </table>
  </section>

</div>


<!-- Project Selection -->
<acc-modal-float (closing)="onResourceSelected($event === true ? undefined : null)"
                 *ngIf="showResourceSelect"
                 title="Select Resource">
  <acc-data-record-selector (recordSelected)="onResourceSelected($event)"
                            [columnNames]="resourceSelectColumns"
                            [records]="resourceRecords">
  </acc-data-record-selector>
</acc-modal-float>

<!-- Edit Allocation Line -->
<acc-modal>
  <form [formGroup]="allocationForm">
    <div class="slds-form__row">
      <div class="slds-form__item" role="listitem">
        <div class="slds-form-element">
          <label class="slds-form-element__label" for="allocation-effort">Resource Total Effort</label>
          <div class="slds-form-element__control">
            <input class="slds-input" formControlName="effort"
                   id="allocation-effort"
                   type="number"/>
          </div>
        </div>
      </div>
      <div class="slds-form__item" role="listitem">
        <div class="slds-form-element">
          <label class="slds-form-element__label" for="allocation-total">Project Line Planned Effort</label>
          <div class="slds-form-element__control">
            <input class="slds-input" formControlName="total"
                   id="allocation-total"
                   type="number"/>
          </div>
        </div>
      </div>
    </div>

    <fieldset class="slds-form-element">
      <legend class="slds-form-element__legend slds-form-element__label">Distribution of Effort</legend>
      <div class="slds-form-element__control">
        <span class="slds-radio">
          <input formControlName="distribution" id="dist-first" type="radio" value="first"/>
          <label class="slds-radio__label" for="dist-first">
            <span class="slds-radio_faux"></span>
            <span class="slds-form-element__label">First days (up to total effort)</span>
          </label>
        </span>
        <span class="slds-radio">
          <input checked="" formControlName="distribution" id="dist-even" type="radio" value="even"/>
          <label class="slds-radio__label" for="dist-even">
            <span class="slds-radio_faux"></span>
            <span class="slds-form-element__label">Even Distribution (all days)</span>
          </label>
        </span>
      </div>
    </fieldset>

    <div class="slds-form__row">
      <div class="slds-form__item" role="listitem">
        <div class="slds-form-element">
          <label class="slds-form-element__label" for="allocation-capacityDay">Max Daily Effort</label>
          <div class="slds-form-element__control">
            <input class="slds-input" formControlName="capacityDay"
                   id="allocation-capacityDay"
                   type="number"/>
          </div>
        </div>
      </div>
      <div class="slds-form__item" role="listitem">
        <div class="slds-form-element">
          <label class="slds-form-element__label" for="allocation-daysWeek">Days per week</label>
          <div class="slds-form-element__control">
            <input class="slds-input" formControlName="daysWeek"
                   id="allocation-daysWeek"
                   type="number"/>
          </div>
        </div>
      </div>
    </div>

  </form>
</acc-modal>
